<template>
  <GraduateApply :applyType="2" />
</template>

<script>
import GraduateApply from './GraduateApply.vue';

export default {
  name: 'DegreeSingleApply',
  components: {
    GraduateApply,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/DegreeSingleApply.vue